import { render } from "./userProfileSettings.vue?vue&type=template&id=07a8e6f0&scoped=true"
import script from "./userProfileSettings.vue?vue&type=script&lang=js"
export * from "./userProfileSettings.vue?vue&type=script&lang=js"

import "./userProfileSettings.vue?vue&type=style&index=0&id=07a8e6f0&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a8e6f0"]])

export default __exports__